<template>
  <div class="cus-cascade">
    <custom-select
        v-model="vModel[0]"
        placeholder="请选择"
        :options="selectOption.options"
        style="width: fit-content; color: #697B8C; margin-left: 10px"
        @visible-change="closePopover"
        @change="hidePopover(true)"
    />

    <el-popover
        style="flex: 1; min-width: 0;"
        ref="popoverRef"
        @show="showPopover"
        @hide="hidePopover"
        :disabled="(vModel[0]==''&&flag==true)"
        popper-class="select-tab-pop"
        :visible-arrow="false"
        placement="bottom-start"
        trigger="click">
      <div slot="reference" class="reference-slot" @mouseout="()=>{this.showDelete = false}"
        :style="{cursor:flag==true?'auto':'pointer'}"
           @mouseover="()=>{this.showDelete = true}">
        <span class="placeholder">{{placeholder}}</span>
        <div class="input-val">{{getShowValue}}</div>
        <div class="input-num" v-show="getShowNum">{{ "+" + getShowNum }}</div>
        <div class="delete-icon">
          <i class="el-icon-circle-close" @click="clearInput" v-show="showDelete"></i>
        </div>
        <i :class="icon" style="margin-left: 8px; margin-right: 8px"></i>
      </div>

      <div class="ca-content">
        <div class="select-tab">
          <template>
            <div class="options-box">
              <el-input
                size="small"
                :placeholder=" '请输入'"
                prefix-icon="el-icon-search"
                :value="searchValue[1]"
                clearable
                @input="(v) => setSearchValue(v, 1)"
                ref="input-1"
              >
              </el-input>
              <div class="select-content">
                <div v-for="item in filterOptions(1)" @click="clickOne(item)" :key="item.name" class="item">
                  <img :src="checkedUrl" v-if="item.isSelected&&!item.hasSelected" alt="" style="width:12px;height:12px;margin-right:4px" @click="(event)=>selectedOne(item,event)"/>
                  <img :src="noCheckedUrl" v-if="!item.isSelected&&!item.hasSelected" alt="" style="width:12px;height:12px;margin-right:4px" @click="(event)=>selectedOne(item,event)"/>
                  <img :src="hasSelectedUrl" v-if="item.hasSelected" alt="" style="width:12px;height:12px;margin-right:4px" @click="(event)=>selectedOne(item,event)"/>
                  <span :class="item.isClicked?'label-active':'label'">{{item.name}}</span>
                  <i class="el-icon-arrow-right icon"></i>
                </div>
              </div>
            </div>
          </template>
          <template>
            <div class="options-box" v-if='second'>
              <div class="select-content" style="padding:0 0px">
                <div v-for="item2 in option2" @click="clickTwo(item2)" :key="item2.name" class="item">
                  <img :src="checkedUrl" v-if="item2.isSelected&&!item2.hasSelected" alt="" style="width:12px;height:12px;margin-right:4px" @click="selectedTwo(item2)"/>
                  <img :src="noCheckedUrl" v-if="!item2.isSelected&&!item2.hasSelected" alt="" style="width:12px;height:12px;margin-right:4px" @click="selectedTwo(item2)"/>
                  <img :src="hasSelectedUrl" v-if="item2.hasSelected"  alt="" style="width:12px;height:12px;margin-right:4px" @click="selectedTwo(item2)"/>
                  <span :class="item2.isClicked?'label-active':'label'">{{item2.name}}</span>
                  <i class="el-icon-arrow-right icon" v-show="item2.children.length>0"></i>
                </div>
              </div>
            </div>
          </template>
          <template>
            <div class="options-box" v-if='third&&!$tool.empty(option3)'>
              <el-input
                size="small"
                :placeholder=" '请输入'"
                prefix-icon="el-icon-search"
                :value="searchValue[3]"
                clearable
                @input="(v) => setSearchValue(v, 3)"
                ref="input-3"
              >
              </el-input>
              <div class="select-content">
                <div v-for="item3 in filterOptions(3)" :key="item3.name" class="item">
                  <img :src="item3.isSelected?checkedUrl:noCheckedUrl" alt="" style="width:12px;height:12px;margin-right:4px" @click="selectedThree(item3)"/>
                  <span :class="item3.isSelected?'label-active':'label'">{{item3.name}}</span>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="cs-submit-btn">
          <div @click="submit">确认</div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import requests from "@/utils/requests";
import CustomSelect from "@/components/customSelect/index.vue";

export default {
  name: "CascadeSelect2",
  components: { CustomSelect },
  props: {
    flag: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Array,
      default: [],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    selectOption: {
      type: Object,
      default: () => {
        return {};
      },
    },
    data:{
      type:Array,
      default:()=>{
        return []
      }
    }
  },
  data() {
    return {
      first: true,
      showDelete: false,
      icon: "el-icon-arrow-down",
      vModel: {
        0: "",
        1: "",
        2: "",
        3: "",
      },
      searchValue: {
        1: "",
        2: "",
        3: "",
      },
      searchResult: {
        1: [],
        2: [],
        3: [],
      },
      option2:[],
      second:false,
      option3:[],
      third:false,
      checkedUrl: require("@/assets/bank/selected.png"),
      noCheckedUrl: require("@/assets/bank/unselected.png"),
      hasSelectedUrl:require("@/assets/bank/hasselected.png"),
      selectedValue:[],
      paramsValue:[],
      batch:'',
      name:'',
      parent:'',
      options: [],// 你的级联数据
    };
  },
  mounted() {
  },
  computed: {
    getShowValue(){
      if(this.selectedValue.length>0){
        return this.selectedValue[0]
      }else{
        return ''
      }
    },
    getShowNum(){
      if(this.selectedValue.length>0){
        return this.selectedValue.length-1
      }else{
        return ''
      }
    }
   
  },
  watch: {
    "vModel.0": {
      // 批次
      handler(v) {
        this.batch = v
        this.data.forEach(batch=>{
          if(batch.name == v){
            this.options = batch.children
            this.paramsValue = [{level:batch.level,parent:batch.parent,name:batch.name,children:[]}]
            this.selectedValue = []
            this.addIsSelectProperty(this.options)
          }
        })
        if(this.data.findIndex(batch=>batch.name==v)<0){
          //选择了全部之后
          this.options = []
          this.selectedValue = []//回显在框里的值
          if(v===''){
            this.paramsValue = []
          }else{
            this.paramsValue = [{level:0,parent:null,name:v,children:[]}]//传递的参数
          }
        }
        this.second = false
        this.third = false
        this.searchValue = {
          1: "",
          2: "",
          3: "",
        };
        this.searchResult = {
          1: "",
          2: "",
          3: "",
        };
        if (!this.first) {
          this.vModel[1] = "";
          this.vModel[2] = "";
          this.vModel[3] = "";
        }
      },
    },
   
    value: {
      handler(v) {
        this.first = true;
        this.paramsValue = v
        if(v.length==0){
          this.selectedValue = []
          this.vModel[0] =''
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
     filterOptions(index){
      if(index==1){
        return this.options.filter(item=>item.name.indexOf(this.searchValue[1])>-1)
      }else if(index==3){
        return this.option3.filter(item=>item.name.indexOf(this.searchValue[3])>-1)
      }

    },
    addIsSelectProperty(options) {
      options.forEach(option => {
        option.isSelected = false;  // 为每个节点添加 isSelected 属性，初始值为 false
        option.hasSelected = false;
        option.isClicked = false

        // 如果该节点有子节点，递归调用该函数
        if (option.children && option.children.length > 0) {
          this.addIsSelectProperty(option.children);
        }
      });
    },
    submit() {
      this.closePopover();
      //获取选中的值
      function getSelectedPaths(options, parentPath = '') {
        //回显在框里的内容
        let paths = [];
        options.forEach(option => {
          const currentPath = parentPath ? `${parentPath}-${option.name}` : option.name;

          if ((option.hasSelected || option.isSelected) && (!option.children || option.children.length === 0)) {
            paths.push(currentPath);
          }

          if (option.children) {
            const childPaths = getSelectedPaths(option.children, currentPath);
            paths = paths.concat(childPaths);
          }
        });

        return paths.filter(path => path.includes('-')); // 去除单个根节点元素
      }
      this.selectedValue = getSelectedPaths(this.options)
      let children = this.filterSelectedOptions(this.options)
      this.paramsValue[0].children = children
    },
    filterSelectedOptions(options) {
    //获取到筛选的树状结构的数据,要作为传参的参数
      return options.map(option => {
      if (option.hasSelected||option.isSelected) {
        if (option.children) {
          const filteredChildren = this.filterSelectedOptions(option.children);
          return { ...option, children: filteredChildren };
        } else {
          return { ...option };
        }
      } else if (option.children) {
        const filteredChildren = this.filterSelectedOptions(option.children);
        if (filteredChildren.length > 0) {
          return { ...option, children: filteredChildren };
        }
      }
      return null;
    }).filter(option => option);
},

    showPopover() {
      this.icon = "el-icon-arrow-up";
      this.first = false;
      this.$nextTick(function () {
        this.$refs["input-1"].focus();
      });
    },
    hidePopover: _.debounce(function (clear = false) {
      this.icon = "el-icon-arrow-down";

      let value = [];
      value = this.paramsValue
      this.$emit("change", value);
      this.$emit("input", value);
    }, 100),
    setSearchValue(v, field) {
      this.searchValue[field] = v;
      // 搜索时，搜索框后面的vModel要置为空   
      if(field==1){
        this.second = false
        this.third = false
      }
      
    },
    closePopover() {
      this.$refs.popoverRef.doClose();
    },
    resetSelections(options) {
        options.forEach(option => {
          option.isSelected = false;
          option.hasSelected = false;
          option.isClicked = false

          if (option.children) {
            this.resetSelections(option.children);
          }
        });
     },
    clearInput(e) {
      this.closePopover();
      this.searchValue[1] = "";
      this.searchValue[2] = "";
      this.searchValue[3] = "";
      this.selectedValue = []
      
      //清空选中的数据
      this.resetSelections(this.options)
      //传参也要清空
      this.data.forEach(batch=>{
        if(batch.name == this.batch){
          this.paramsValue = [{level:batch.level,parent:batch.parent,name:batch.name,children:[]}]
        }
      })
      this.hidePopover();
      e.stopPropagation();
    },
    clickOne(v){
      this.option2 = v.children
      this.second = true
      this.third = false
      this.options.forEach(item=>{
        if(item.name == v.name){
          item.isClicked = true
        }else{
          item.isClicked = false
        }
        
      })
      this.$forceUpdate()
      this.searchValue[3] =''
    },
    selectedOne(v,event){
      v.isSelected = !v.isSelected
      if(v.isSelected){
        v.hasSelected = false
      }
      this.second = true
      this.third = true
      this.option2 = v.children
      this.options.forEach(item=>{
        if(item.name == v.name){
          item.isClicked = true
        }else{
          item.isClicked = false
        }
        
      })
      this.searchValue[3] =''
      if(v.children.length>0){
        if(v.children[0]?.children.length>0){
          v.children[0].isClicked = true
          this.option3 = v.children[0].children
        }
      }
      if(v.children?.length>0){
        v.children.forEach(subItem=>{
          subItem.isSelected = v.isSelected
          if(subItem.children?.length>0){
            subItem.children.forEach(sub_subItem=>{
              sub_subItem.isSelected = v.isSelected
            })
          } 
          })
      }
      this.$forceUpdate()
      event.stopPropagation()
    },
    selectedTwo(v){
      v.isSelected = !v.isSelected
      if(v.isSelected){
        v.hasSelected = false
      }
      if(v.children?.length>0){
        v.children.forEach(thirdItem=>{
          thirdItem.isSelected = v.isSelected
        })
      }
      this.$forceUpdate()
      this.checkSelected()
      this.searchValue[3] = ''

    },
    checkSelected(){
      //点击选中了2级，就要去1级看选中情况
      this.options.forEach(item=>{
       if(item.children.every(subItem=>subItem.isSelected)){
          item.isSelected = true
          item.hasSelected = false
        }else if(item.children.every(subItem=>!subItem.isSelected)){
          item.isSelected = false
          item.hasSelected = false
        }else if(item.children.find(subItem=>subItem.isSelected)||!item.children.every(subItem=>subItem.isSelected)){
          item.hasSelected = true
          item.isSelected = false
        }else{
          item.hasSelected = false
        }
      })

    },
    
    clickTwo(v){
      //第二级菜单
      this.option3 = v.children
      this.third = true
      this.option2.forEach(item=>{
        if(item.name == v.name){
          item.isClicked = true
        }else{
          item.isClicked = false
        }
        
      })
      this.$forceUpdate()
      this.searchValue[3] =''
    },
    selectedThree(v){
      v.isSelected = !v.isSelected
      this.option2.forEach(twoItem=>{
        if(!v.isSelected){
          if(twoItem.name==v.parent){
            twoItem.isSelected = v.isSelected
          }
        }

      })
      this.$forceUpdate()
      this.checkoption3Selected(v)
    },
    checkoption3Selected(v){
      this.option2.forEach(item=>{
        if(item.children.every(subItem=>subItem.isSelected)){
          item.isSelected = true
          item.hasSelected = false
        }else if(item.children.every(subItem=>!subItem.isSelected)){
          item.isSelected = false
          item.hasSelected = false
        }else if(item.children.find(subItem=>subItem.isSelected)||!item.children.every(subItem=>subItem.isSelected)){
          item.hasSelected = true
          item.isSelected = false
        }else{
          item.hasSelected = false
        }
      })
      let parent = this.option2.find(item2=>item2.name==v.parent)
      let bigParent = this.options.find(item=>item.name == parent.parent)
      if(bigParent.children.find(item2=>item2.hasSelected)){
        //有选中的就优先展示有选中的标签
        bigParent.hasSelected = true
        bigParent.isSelected = false
      }
      if(bigParent.children.every(item2=>!item2.hasSelected)&&bigParent.children.every(item2=>!item2.isSelected)){
        //判断是不是没有，选中部分和全选的
        bigParent.hasSelected = false
        bigParent.isSelected = false
        
      }else{
        //说明有选中部分或者有全选的
        if(bigParent.children.every(item2=>item2.isSelected)){
          //判断是否全部选中
          bigParent.isSelected = true
          bigParent.hasSelected = false
        }else{
          //只有部分选中
          bigParent.hasSelected = true

        }
        
      }
      

    }
  },
};
</script>

<style scoped lang="less" scoped>
@import "/src/style/variables";
.reference-slot {
  display: flex;
  align-items: center;
  color: #d9d9d9;
  height: 32px;
  font-size: 14px;
  cursor: pointer;

  .placeholder {
    margin: 0 8px;
    white-space: nowrap;
  }

  .input-val {
    color: #606266;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;
    flex:1
    }

  .input-num {
    color: #d9d9d9;
    margin-right: 16px;
  }

  .delete-icon {
    width: 16px;
    text-align: center;
    margin-left: 8px;
    position:absolute;
    right:32px
  }
}

.cus-cascade {
  flex: 1;
  display: flex;
  border-radius: 4px;
  padding: 0 2px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-sizing: border-box;
  height: 32px;
  align-items: center;
}

.select-tab {
  display: flex;

  .options-box {
    padding: 0 2px;
    border-right: 1px solid #d9d9d9;
    width: 220px;

    .item {
      min-width: 200px;
      line-height: 32px;
      margin-bottom: 2px;
      padding: 0 14px;
      cursor: pointer;
      display:flex;
      margin-top: 2px;
      align-items: center;
    }
    .item:hover{
      background-color: #EFF4FF;
    }
    .icon{
     color:rgba(0,0,0,.88);
     margin-top:1px;
     padding-left:20px
    }

    .active {
      border-radius: 6px;
      color: @--color-primary;
    }
  }

  .options-box:last-child {
    padding-right: 0;
    border-right: unset;
  }

  .select-content {
    height: 200px;
    overflow-y: auto;
  }

  .select-content::-webkit-scrollbar {
    display: none;
  }
}

::v-deep .el-input__inner {
  border: none;
  height: 29px;
}

::v-deep .el-select {
  border-right: 1px solid #d9d9d9;
}

::v-deep .options-box .el-input__inner {
  border: 1px solid #d9d9d9;
}
.select-tab ::v-deep .el-popover__reference-wrapper {
  flex: 1;
  min-width: 0;
}
.ca-content {
  .cs-submit-btn {
    float: right;
    margin-top: 10px;
    div {
      width: 60px;
      height: 28px;
      background: @--color-primary;
      border-radius: 4px;
      text-align: center;

      font-size: 14px;
      color: #ffffff;
      line-height: 28px;

      cursor: pointer;
    }
  }
}
</style>
<style>
.select-tab-pop {
  margin-left: 0px !important;
  margin-top: 4px !important;
}
.label{
  color:rgba(0,0,0,.88);
  font-size: 14px;
}
.label-active{
  color:#3371FF;
  font-size:14px
}
</style>